<template>
    <div>
        <div class="workcategories">
            <InformativeItem v-for="(work, index) in works"
                            :index="index"
                            :key="index"
                            :icon="work.icon"
                            :title="work.title"
                            :items="work.clients"/>
        </div>
    </div>
</template>

<script>
import InformativeItem from '@/components/InformativeItem'
export default {
    name: 'workcategories',
    data: () => ({
        works: [
          {
              icon: require('../assets/icons/darkblue-gem.png'),
              title: 'Saúde',
              clients: ['Hospital Sírio-Libanês', 'Dasa', 'Hospital das Clínicas', 'Implamed','Fusão','Convatec','4Life', 'Pro-health'],
          },
          {
              icon: require('../assets/icons/pink-gem-3.png'),
              title: 'Tecnologia',
              clients: ['Accenture', 'Siemens', 'Motorola', 'Rontan Telecom', 'Landell'],
          },
          {
              icon: require('../assets/icons/pink-gem.png'),
              title: 'Ensino',
              clients: ['Ensino Sírio-Libanês','Faculdade de Medicina da USP','HC Business School', 'Athena'],
          },
          {
              icon: require('../assets/icons/blue-triangle.svg'),
              title: 'Viagens e intercâmbio',
              clients: ['Apply','Assist Card','Hello Study'],
          },
          {
              icon: require('../assets/icons/green-gem.png'),
              title: 'Imobiliário',
              clients: ['Camargo Corrêa','FYP','CBRE', 'Frischmann Tessler'],
          },
          {
              icon: require('../assets/icons/yellow-gem-horizontal.svg'),
              title: 'Indústrias',
              clients: ['YKK','Grupo Combustol','Açobril'],
          },
          {
              icon: require('../assets/icons/tetris-piece-2.svg'),
              title: 'Serviços',
              clients: ['Bradesco', 'Multiplus','Solid Leilões','ATME Eco-solutions'],
          },
          {
              icon: require('../assets/icons/pink-gem-2.png'),
              title: 'Medicamentos e cosméticos',
              clients: ['Roche','Peel Line','Galderma', 'Merz'],
          },
          {
              icon: require('../assets/icons/blue-gem-2.png'),
              title: 'Consultoria',
              clients: ['Hoffmann','Lotus','Emar','Rödl & Partner'],
          },
          {
              icon: require('../assets/icons/yellow-gem-2.png'),
              title: 'Recursos humanos',
              clients: ['Linco','Valuing','Meritor','Trend'],
          },
          {
              icon: require('../assets/icons/digital-art-draw.svg'),
              title: 'Alimentos e bebidas',
              clients: ['Casa Doce','Sushi San','Mussanela','Mipi','Fatia de Saúde'],
          },
          {
              icon: require('../assets/icons/pink-gem-4.png'),
              title: 'Seguros e Convênios',
              clients: ['Porto Seguro','Unimed'],
          },
          {
              icon: require('../assets/icons/digital-art-retangle-2.svg'),
              title: 'Startups',
              clients: ['Vale Presente World','Arietta', 'Valen'],
          },
          {
              icon: require('../assets/icons/blue-gem-3.png'),
              title: 'Construção Civil',
              clients: ['Andres Romano','Thek', 'Rainha'],
          },
          {
              icon: require('../assets/icons/green-gem-2.png'),
              title: 'Comunicação',
              clients: ['Editora Gente','Piar','Agência Vitamina', 'Dinâmica'],
          },
          {
              icon: require('../assets/icons/blue-triangle.svg'),
              title: 'Estabelecimentos',
              clients: ['Shopping West Plaza','Rotary Club São Paulo','Atlantica Hotels'],
          }
        ]
    }),
    components: {
        InformativeItem,
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/vars';
.workcategories {
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;

    @media (min-width: $min-md) {
        gap: 16rem 3rem;
        width: 111rem;
    }
    @media (max-width: $max-sm) {
        grid-template-columns: 1fr;
        width: 100vw;
    }
}
</style>
